(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomGroupTypeAttributeDialogController', CustomGroupTypeAttributeDialogController);

    CustomGroupTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'CustomGroupTypeAttribute'];

    function CustomGroupTypeAttributeDialogController ($timeout, $scope, $state, $stateParams, entity, CustomGroupTypeAttribute) {
        var vm = this;

        vm.customGroupTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.customgrouptypeattributevalues = CustomGroupTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customGroupTypeAttribute.customGroupTypeAttributeValues != null && vm.customGroupTypeAttribute.customGroupTypeAttributeValues.length != 0) {
			vm.items = vm.customGroupTypeAttribute.customGroupTypeAttributeValues;
		}
        
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
           // $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customGroupTypeAttribute.id !== null) {
            	
            	 vm.customGroupTypeAttribute.customGroupTypeAttributeValues = [];
 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customGroupTypeAttribute.customGroupTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
            	
                CustomGroupTypeAttribute.update(vm.customGroupTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customGroupTypeAttribute.customGroupTypeAttributeValues = [];

 				for (var i = 0; i < vm.items.length; i++) {
 					 vm.customGroupTypeAttribute.customGroupTypeAttributeValues.push({
 						"id" : vm.items[i].id,
 						"value" : vm.items[i].value
 					});

 				}
                CustomGroupTypeAttribute.save(vm.customGroupTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customGroupTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-group-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
